import { render, staticRenderFns } from "./LeadsDashboard.vue?vue&type=template&id=55cd6205&scoped=true&"
import script from "./LeadsDashboard.vue?vue&type=script&lang=js&"
export * from "./LeadsDashboard.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./LeadsDashboard.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./LeadsDashboard.vue?vue&type=style&index=2&id=55cd6205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd6205",
  null
  
)

export default component.exports